import React, { Component } from 'react';
import { Tooltip, Overlay } from 'react-bootstrap';

import styles from './TooltipCommerce.css';

/**
 * need to hide this footer first
 * because its linked to another pages that not finish yet
 */

// const TooltipFooter = () => (
//   <div className={styles['tooltip-footer']}>
//     <div className={styles['tooltip-footer-desc']}>
//       <span> Don't have an online store yet? </span>
//       <span> Integrate your offline store to online now! </span>
//     </div>
//     <div>
//       <button className={`btn ${styles['tooltip-footer-button']}`}>
//         Create Online Store
//       </button>
//     </div>
//   </div>
// );

export default class TooltipCommerce extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
    };
  }

  handleMouseEnter = () => {
    const { delay, onMouseEnter } = this.props;

    this.setTimeoutConst = setTimeout(() => {
      this.setState({ showPopover: true }, () => {
        if (onMouseEnter) {
          onMouseEnter();
        }
      });
    }, delay);
  };

  handleMouseLeave = () => {
    clearTimeout(this.setTimeoutConst);
    this.setState({ showPopover: false });
  };

  renderTooltipContainer = () => {
    const { name } = this.props;
    switch (name) {
      case 'item':
        return (
          <div className={styles['tooltip-content-container']}>
            <div className={styles['tooltip-content']}>
              <h5>These fields are required for online selling</h5>
              <span>
                All the below details will be displayed on the product pages of
                your online store
              </span>
            </div>
            {/* <TooltipFooter /> */}
          </div>
        );
      case 'price':
        return (
          <div className={styles['tooltip-content-container']}>
            <div className={styles['tooltip-content']}>
              <h5>Price is required for online selling</h5>
              <span>
                It will be displayed on the product pages of your online store
              </span>
            </div>
            {/* <TooltipFooter /> */}
          </div>
        );
      case 'basePrice':
        return (
          <div className={styles['tooltip-content-base-price']}>
            <span>
              This will be the default price for all sales type & online store.
            </span>
          </div>
        );
      case 'sku':
        return (
          <div className={styles['tooltip-content-base-price']}>
            <span>
              Fill with your product code. Recommended to use global product
              code: GTIN/UPC/EAN/ISBN number.
            </span>
          </div>
        );
      default:
        return (
          <div className={styles['tooltip-content-container']}>
            <div className={styles['tooltip-content']}>
              <h5> This Field is Required for Online Selling </h5>
              <span>
                These detail informations are required for your online store
                products to help customer when buying your product.
              </span>
            </div>
            {/* <TooltipFooter /> */}
          </div>
        );
    }
  };

  componentWillUnmount() {
    if (this.setTimeoutConst) {
      clearTimeout(this.setTimeoutConst);
    }
  }

  render() {
    const { children, placement } = this.props;

    const child = React.Children.map(children, child =>
      React.cloneElement(child, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: node => {
          this._child = node;
          const { ref } = child;
          if (typeof ref === 'function') {
            ref(node);
          }
        },
      })
    )[0];

    return (
      <div>
        {child}
        <Overlay
          show={this.state.showPopover}
          placement={placement}
          target={this._child}
          shouldUpdatePosition
        >
          <Tooltip
            id="popover-trigger"
            onMouseEnter={() => {
              this.setState({ showPopover: true });
            }}
            onMouseLeave={this.handleMouseLeave}
          >
            {this.renderTooltipContainer()}
          </Tooltip>
        </Overlay>
      </div>
    );
  }
}
